import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ButtonBlue = styled(Button)({
  backgroundColor: '#3182ce',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: '600',
  padding: '12px 24px',
  color: 'white',
  textTransform: 'none',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  boxShadow: '0 4px 6px -1px rgba(49, 130, 206, 0.2), 0 2px 4px -1px rgba(49, 130, 206, 0.1)',
  '&:hover': {
    backgroundColor: '#2b6cb0',
    boxShadow: '0 10px 15px -3px rgba(49, 130, 206, 0.3), 0 4px 6px -2px rgba(49, 130, 206, 0.15)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  '&.Mui-disabled': {
    backgroundColor: '#cbd5e0',
    color: '#718096',
  },
});

export default ButtonBlue;
